// import tdf from '@/Utilities/TableDataFormatter.js'
// import numeral from '??'
// import moment from '??'

export default {
  
  data(){
    return {
      // Place default formatters in here
      // _f:{
      //   day: "ddd MMMM Do YYYY, h:mm a"
      // }
    }
  },

  methods:{
    D: function(val, formatter="ddd MMMM Do YYYY, h:mm a", invalidDateText=""){
      const result = moment.utc(val).format(formatter);
      return result === "Invalid date" ? invalidDateText : result;
    },
  
    F: function(val, formatter='0,000.00'){
      return numeral(val).format(formatter);
    },
  },

  filters:{
    DF: function(val, formatter="ddd MMMM Do YYYY, h:mm a", invalidDateText=""){
        const result = moment.utc(val).format(formatter);
        return result === "Invalid date" ? invalidDateText : result;
    },
  
    NF: function(val, formatter='0,000.00'){
      return numeral(val).format(formatter);
    },
  },
  

}